import { render, staticRenderFns } from "./ReactivationCourse.vue?vue&type=template&id=21a08a6d&scoped=true&"
import script from "./ReactivationCourse.vue?vue&type=script&lang=js&"
export * from "./ReactivationCourse.vue?vue&type=script&lang=js&"
import style0 from "./ReactivationCourse.vue?vue&type=style&index=0&id=21a08a6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a08a6d",
  null
  
)

export default component.exports